import { render, staticRenderFns } from "./InvoiceBook1.vue?vue&type=template&id=1afbc473"
import script from "./InvoiceBook1.vue?vue&type=script&lang=js"
export * from "./InvoiceBook1.vue?vue&type=script&lang=js"
import style0 from "./InvoiceBook1.vue?vue&type=style&index=0&id=1afbc473&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports